import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedDocumentsRoute extends Route {}
